import { Controller } from "@hotwired/stimulus";

export default class EvaluationSummationController extends Controller {
  static targets = [
    'typeOneSum', 'typeTwoSum', 'typeThreeSum', 'TypeFourSum',
    'typeOneInput', 'typeTwoInput', 'typeThreeInput', 'typeFourInput', 'rankInput'
  ];

  // Lifecycle Callback Methods
  typeOneSumTargetConnected(target) {
    target.textContent = this.#sumTargetsValues(this.typeOneInputTargets);
  }

  typeTwoSumTargetConnected(target) {
    target.textContent = this.#sumTargetsValues(this.typeTwoInputTargets);
  }

  typeThreeSumTargetConnected(target) {
    target.textContent = this.#sumTargetsValues(this.typeThreeInputTargets);
  }

  typeFourSumTargetConnected(target) {
    target.textContent = this.#sumTargetsValues(this.typeFourInputTargets);
  }

  rankSumTargetConnected(target) {
    target.textContent = this.#sumTargetsValues(this.rankInputTargets);
  }

  // Actions
  sum(e) {
    const fieldName = e.currentTarget.dataset.field;

    const summationField = this.targets.findTarget(`${fieldName}Sum`);
    const inputFields = this.targets.findAllTargets(`${fieldName}Input`);

    summationField.textContent = this.#sumTargetsValues(inputFields);
  }

  // Private Methods
  #sumTargetsValues(targets) {
    return targets.reduce((partialSum, element) => {
      if (!element.value || element.value.trim() === '') return partialSum;

      return partialSum + parseFloat(element.value);
    }, 0);
  }
}
